import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../api';

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [organizer, setOrganizer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('tikoo_token');
    if (token) {
      authAPI.me().then(r => setOrganizer(r.data)).catch(() => {
        localStorage.removeItem('tikoo_token');
      }).finally(() => setLoading(false));
    } else { setLoading(false); }
  }, []);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('tikoo_token', res.data.token);
    setOrganizer(res.data.organizer);
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('tikoo_token');
    setOrganizer(null);
  };

  return (
    <AuthContext.Provider value={{ organizer, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
